import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { fetcher } from '../../utils/gql/fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: string; output: string };
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: { input: string; output: string };
  UUID: { input: string; output: string };
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION',
}

export type AreaDto = {
  __typename?: 'AreaDto';
  areaTenants?: Maybe<Array<AreaTenantDto>>;
  deactivationReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefaultSharedArea: Scalars['Boolean']['output'];
  point?: Maybe<PointDto>;
  pointId: Scalars['UUID']['output'];
  storageUnits?: Maybe<Array<StorageUnitDto>>;
  tenantSubjectIds?: Maybe<Array<Scalars['UUID']['output']>>;
};

export type AreaTenantDto = {
  __typename?: 'AreaTenantDto';
  area?: Maybe<AreaDto>;
  areaId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  tenantSubjectId: Scalars['UUID']['output'];
};

/** Unified audit event showing activity across courier, customer, point, and package views */
export type AuditEventDto = {
  __typename?: 'AuditEventDto';
  /** List of credentials used by the courier for authentication */
  courierCredentials?: Maybe<Array<Maybe<CourierCredential>>>;
  /** Courier PIN credential ID */
  courierPinCredentialId?: Maybe<Scalars['UUID']['output']>;
  /** List of credentials used by the customer for authentication */
  customerCredentials?: Maybe<Array<Maybe<CustomerCredential>>>;
  /** Customer emails */
  customerEmails?: Maybe<Array<ClientEmail>>;
  /** Customer phone numbers */
  customerPhoneNumbers?: Maybe<Array<ClientPhoneNumber>>;
  /** Customer PIN credential ID */
  customerPinCredentialId?: Maybe<Scalars['UUID']['output']>;
  /** Event subject (e.g., 'Reservation.StockedIn', 'Point.StatusOnlineReported') */
  eventSubject: Scalars['String']['output'];
  /** Installation timezone (e.g., 'Europe/Prague') */
  installationTimezone?: Maybe<Scalars['String']['output']>;
  /** Local time at the point location (converted from UTC using timezone) */
  localTime?: Maybe<Scalars['DateTime']['output']>;
  /** Current lock status (Locked, Unlocked, etc.) */
  lockStatus: LockStatus;
  /** Original message type */
  messageName: Scalars['String']['output'];
  /** Additional metadata */
  metadata?: Maybe<Array<KeyValuePairOfStringAndString>>;
  /** Payment information (amount, status, receipt, etc.) */
  paymentInfo?: Maybe<PaymentInfoDto>;
  /** Physical address of the point */
  pointAddress?: Maybe<Scalars['String']['output']>;
  /** Point (locker) identifier */
  pointId?: Maybe<Scalars['UUID']['output']>;
  /** Point identifier (registration number) */
  pointIdentifier?: Maybe<Scalars['String']['output']>;
  /** Point registration number */
  pointRegistrationNumber?: Maybe<Scalars['String']['output']>;
  /** Why the reservation was cancelled (when applicable) */
  reservationCancellationReason?: Maybe<ReservationCancellationReason>;
  /** Why the reservation's allocations were released (when applicable) */
  reservationDeallocationReason?: Maybe<ReservationDeallocationReason>;
  /** Reservation ID */
  reservationId?: Maybe<Scalars['UUID']['output']>;
  /** Storage units with identifier and name */
  storageUnits?: Maybe<Array<StorageUnitInfoDto>>;
  /** Tenant subject identifier */
  tenantSubjectId?: Maybe<Scalars['UUID']['output']>;
  /** Tenant/company name */
  tenantSubjectName?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the event occurred (UTC) */
  timestampUtc: Scalars['DateTime']['output'];
  /** All tracking identifiers */
  trackingIdentifiers: Array<Scalars['String']['output']>;
  /** User ID associated with the event */
  userId?: Maybe<Scalars['UUID']['output']>;
  /** User information resolved from the Identity API */
  userInfo?: Maybe<UserInfoDto>;
};

/** Paginated list of audit events */
export type AuditEventPaginatedListDto = {
  __typename?: 'AuditEventPaginatedListDto';
  /** Whether there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The audit events in this page */
  items: Array<AuditEventDto>;
  /** Current page index (0-based) */
  pageIndex: Scalars['Int']['output'];
  /** Number of items per page */
  pageSize: Scalars['Int']['output'];
  /** Total number of items across all pages */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

/** All allowed audit subjects grouped by view type */
export type AuditSubjects = {
  __typename?: 'AuditSubjects';
  /** Allowed subjects for Contact view */
  contact: Array<Scalars['String']['output']>;
  /** Allowed subjects for Courier view */
  courier: Array<Scalars['String']['output']>;
  /** Allowed subjects for Package view */
  package: Array<Scalars['String']['output']>;
  /** Allowed subjects for Point/Locker view */
  point: Array<Scalars['String']['output']>;
};

/** Client email information */
export type ClientEmail = {
  __typename?: 'ClientEmail';
  /** Client type (Sender, Recipient, etc.) */
  clientType: ClientType;
  /** Email address */
  email: Scalars['String']['output'];
};

/** Client phone number information */
export type ClientPhoneNumber = {
  __typename?: 'ClientPhoneNumber';
  /** Client type (Sender, Recipient, etc.) */
  clientType: ClientType;
  /** Phone number */
  phoneNumber: Scalars['String']['output'];
};

export enum ClientType {
  Depositor = 'DEPOSITOR',
  Recipient = 'RECIPIENT',
  Sender = 'SENDER',
}

export type CompanyTableItemDto = {
  __typename?: 'CompanyTableItemDto';
  id: Scalars['UUID']['output'];
  isProvider: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  logoUrlUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  subjectId: Scalars['UUID']['output'];
  teamsMembersCount: Scalars['Int']['output'];
  type: CompanyType;
};

export enum CompanyType {
  Big = 'BIG',
  Conteg = 'CONTEG',
  DevelopmentAndTesting = 'DEVELOPMENT_AND_TESTING',
  Small = 'SMALL',
}

export type CoolingDto = {
  __typename?: 'CoolingDto';
  id: Scalars['UUID']['output'];
};

/** Courier credential with type and value */
export type CourierCredential = {
  __typename?: 'CourierCredential';
  /** Type of courier credential (Pin, PersonIdentifier) */
  type: CourierCredentialType;
  /** Value of the credential */
  value?: Maybe<Scalars['String']['output']>;
};

export enum CourierCredentialType {
  PersonIdentifier = 'PERSON_IDENTIFIER',
  Pin = 'PIN',
}

export enum Currency {
  Czk = 'CZK',
  Default = 'DEFAULT',
  Eur = 'EUR',
  Gbp = 'GBP',
  Ron = 'RON',
  Rub = 'RUB',
  Usd = 'USD',
}

/** Customer credential with type and value */
export type CustomerCredential = {
  __typename?: 'CustomerCredential';
  /** Type of customer credential (Pin, Phone, Email) */
  type: CustomerCredentialType;
  /** Value of the credential */
  value?: Maybe<Scalars['String']['output']>;
};

export enum CustomerCredentialType {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Pin = 'PIN',
}

export type DeviceDto = {
  __typename?: 'DeviceDto';
  cooling?: Maybe<CoolingDto>;
  deviceModelNumber?: Maybe<Scalars['String']['output']>;
  deviceType: DeviceType;
  id: Scalars['UUID']['output'];
  installation?: Maybe<InstallationDto>;
  installationId?: Maybe<Scalars['UUID']['output']>;
  kioskPc?: Maybe<KioskPcDto>;
  lock?: Maybe<LockDto>;
  lockController?: Maybe<LockControllerDto>;
  lockNetworkUnit?: Maybe<LockNetworkUnitDto>;
  note?: Maybe<Scalars['String']['output']>;
  paymentTerminal?: Maybe<PaymentTerminalDto>;
  pointId?: Maybe<Scalars['UUID']['output']>;
  printer?: Maybe<PrinterDto>;
  relay?: Maybe<RelayDto>;
  router?: Maybe<RouterDto>;
  touchDisplay?: Maybe<TouchDisplayDto>;
};

export enum DeviceType {
  Cooling = 'COOLING',
  KioskPc = 'KIOSK_PC',
  Lock = 'LOCK',
  LockController = 'LOCK_CONTROLLER',
  LockNetworkUnit = 'LOCK_NETWORK_UNIT',
  PaymentTerminal = 'PAYMENT_TERMINAL',
  Printer = 'PRINTER',
  Relay = 'RELAY',
  Router = 'ROUTER',
  TouchDisplay = 'TOUCH_DISPLAY',
}

export enum DisplayRotationDirection {
  Left = 'LEFT',
  Right = 'RIGHT',
}

export type ExportSmsDto = {
  __typename?: 'ExportSmsDto';
  messagesCount: Scalars['Int']['output'];
  pointId?: Maybe<Scalars['UUID']['output']>;
  pointRegistrationNumber?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['UUID']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  smsMessagesCount: Scalars['Int']['output'];
  tenantSubjectId?: Maybe<Scalars['UUID']['output']>;
  tenantSubjectName?: Maybe<Scalars['String']['output']>;
};

export type InstallationDto = {
  __typename?: 'InstallationDto';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  deactivationReason?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  geoRegion?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  isIndoor: Scalars['Boolean']['output'];
  isParkingPossible: Scalars['Boolean']['output'];
  isVisuallyImpairedAccessible: Scalars['Boolean']['output'];
  isWheelchairAccessible: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  locationDescription?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  maximalAmbientTemperature: Scalars['Float']['output'];
  maximalEvaporatorTemperature: Scalars['Float']['output'];
  maximalInternalPointTemperature: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  openingHourExceptionsSummary?: Maybe<Scalars['String']['output']>;
  operatingHours?: Maybe<Array<OperatingHoursDto>>;
  ownerSubjectId: Scalars['UUID']['output'];
  partOfCity?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Array<PointDto>>;
  postalCode?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['UUID']['output'];
  providerSubjectId: Scalars['UUID']['output'];
  region?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  streetOrientationNumber?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type KeyValuePairOfStringAndString = {
  __typename?: 'KeyValuePairOfStringAndString';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type KioskPcDto = {
  __typename?: 'KioskPcDto';
  ipAddress?: Maybe<Scalars['String']['output']>;
};

export type LockControllerDto = {
  __typename?: 'LockControllerDto';
  description?: Maybe<Scalars['String']['output']>;
};

export type LockDto = {
  __typename?: 'LockDto';
  fallbackLockOpenAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  lastLockOpenRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  lastStatus: LockStatus;
  lockIdentifier?: Maybe<Scalars['String']['output']>;
  storageUnit?: Maybe<StorageUnitDto>;
  storageUnitId: Scalars['UUID']['output'];
};

export type LockNetworkUnitDto = {
  __typename?: 'LockNetworkUnitDto';
  ipAddress?: Maybe<Scalars['String']['output']>;
  port: Scalars['Int']['output'];
};

export enum LockStatus {
  Closed = 'CLOSED',
  Failed = 'FAILED',
  Opened = 'OPENED',
}

export type OperatingHoursDto = {
  __typename?: 'OperatingHoursDto';
  dayOfWeek: Scalars['Int']['output'];
  endTime?: Maybe<Scalars['TimeSpan']['output']>;
  id: Scalars['UUID']['output'];
  installation?: Maybe<InstallationDto>;
  installationId: Scalars['UUID']['output'];
  isAllDayClosed: Scalars['Boolean']['output'];
  isUnexpected: Scalars['Boolean']['output'];
  startTime?: Maybe<Scalars['TimeSpan']['output']>;
  unexpectedDateTime?: Maybe<Scalars['DateTime']['output']>;
};

/** Payment transaction information */
export type PaymentInfoDto = {
  __typename?: 'PaymentInfoDto';
  /** Payment amount (as string) */
  amount?: Maybe<Scalars['String']['output']>;
  /** Currency code (CZK, EUR, USD, etc.) */
  currency?: Maybe<Currency>;
  /** Unique payment transaction identifier */
  paymentId?: Maybe<Scalars['UUID']['output']>;
  /** URL to the payment receipt page */
  receiptLink?: Maybe<Scalars['String']['output']>;
  /** Payment status: Processed, Rejected, Reversed */
  status?: Maybe<Scalars['String']['output']>;
  /** Payment gateway response code */
  transactionResponseCodeName?: Maybe<TransactionResponseCode>;
};

export type PaymentTerminalDto = {
  __typename?: 'PaymentTerminalDto';
  currency: Currency;
  deviceId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  lastLifeCheck?: Maybe<Scalars['DateTime']['output']>;
  pid?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export type PointDto = {
  __typename?: 'PointDto';
  areas?: Maybe<Array<AreaDto>>;
  deactivationReason?: Maybe<Scalars['String']['output']>;
  devices?: Maybe<Array<DeviceDto>>;
  heightFromGroundInMillimeters: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  installation?: Maybe<InstallationDto>;
  installationId: Scalars['UUID']['output'];
  internetSpeedDownloadBytes?: Maybe<Scalars['Float']['output']>;
  internetSpeedMeasuredAt?: Maybe<Scalars['DateTime']['output']>;
  internetSpeedUploadBytes?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  isConfigured: Scalars['Boolean']['output'];
  isManualLayoutManagement: Scalars['Boolean']['output'];
  isOpenForEdit: Scalars['Boolean']['output'];
  localApplicationVersion?: Maybe<Scalars['String']['output']>;
  pointIdentifier?: Maybe<Scalars['String']['output']>;
  pointPrefix?: Maybe<Scalars['String']['output']>;
  pointRegistrationNumber?: Maybe<Scalars['String']['output']>;
  pointSequenceNumber: Scalars['Int']['output'];
  storageColumns?: Maybe<Array<StorageColumnDto>>;
  tags?: Maybe<Array<PointTagDto>>;
};

export type PointMessageDto = {
  __typename?: 'PointMessageDto';
  deactivationReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  installationId: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isConfigured: Scalars['Boolean']['output'];
  isManualLayoutManagement: Scalars['Boolean']['output'];
  isOpenForEdit: Scalars['Boolean']['output'];
  pointIdentifier?: Maybe<Scalars['String']['output']>;
  pointPrefix?: Maybe<Scalars['String']['output']>;
  pointRegistrationNumber?: Maybe<Scalars['String']['output']>;
  pointSequenceNumber: Scalars['Int']['output'];
};

export type PointTagDto = {
  __typename?: 'PointTagDto';
  id: Scalars['UUID']['output'];
  point?: Maybe<PointDto>;
  pointId: Scalars['UUID']['output'];
  tag: Tag;
};

export type PrinterDto = {
  __typename?: 'PrinterDto';
  device?: Maybe<DeviceDto>;
  deviceId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  status?: Maybe<Array<PrinterStatus>>;
};

export enum PrinterStatus {
  ConnectionNoBixolonPrinter = 'CONNECTION_NO_BIXOLON_PRINTER',
  ConnectionNoConnectedPrinter = 'CONNECTION_NO_CONNECTED_PRINTER',
  ConnectionPortOpenError = 'CONNECTION_PORT_OPEN_ERROR',
  CoverOpen = 'COVER_OPEN',
  CutterError = 'CUTTER_ERROR',
  Ok = 'OK',
  Overheatting = 'OVERHEATTING',
  PaperEmpty = 'PAPER_EMPTY',
  PaperIn = 'PAPER_IN',
  PaperJam = 'PAPER_JAM',
  PaperNearEnd = 'PAPER_NEAR_END',
  PaperToBeTaken = 'PAPER_TO_BE_TAKEN',
  Unknown = 'UNKNOWN',
  UnrecoverableError = 'UNRECOVERABLE_ERROR',
}

export type Query = {
  __typename?: 'Query';
  /** Get all allowed subjects grouped by view type */
  allAuditSubjects: AuditSubjects;
  /** Get all companies */
  companies?: Maybe<Array<Maybe<CompanyTableItemDto>>>;
  contactAuditMessages?: Maybe<AuditEventPaginatedListDto>;
  courierAuditMessages?: Maybe<AuditEventPaginatedListDto>;
  packageAuditMessages?: Maybe<AuditEventPaginatedListDto>;
  pointAuditMessages?: Maybe<AuditEventPaginatedListDto>;
  points?: Maybe<Array<Maybe<PointMessageDto>>>;
  sentSmsLogs: Array<ExportSmsDto>;
  /** Get all storage units for a specific point */
  storageUnitsByPoint: Array<StorageUnitDto>;
};

export type QueryContactAuditMessagesArgs = {
  contactIdentifier: Scalars['String']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  subjects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryCourierAuditMessagesArgs = {
  courierIdentifier: Scalars['String']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  subjects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tenantSubjectId?: InputMaybe<Scalars['UUID']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryPackageAuditMessagesArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  subjects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPointAuditMessagesArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pointId?: InputMaybe<Scalars['UUID']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  storageUnitId?: InputMaybe<Scalars['UUID']['input']>;
  subjects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuerySentSmsLogsArgs = {
  pointId?: InputMaybe<Scalars['UUID']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  smsSentAtFrom?: InputMaybe<Scalars['String']['input']>;
  smsSentAtTo?: InputMaybe<Scalars['String']['input']>;
  tenantSubjectId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryStorageUnitsByPointArgs = {
  pointId: Scalars['UUID']['input'];
};

export type RelayDto = {
  __typename?: 'RelayDto';
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export enum ReservationCancellationReason {
  CancelledByPartnerRemotely = 'CANCELLED_BY_PARTNER_REMOTELY',
  CancelledViaMaintenanceWeb = 'CANCELLED_VIA_MAINTENANCE_WEB',
  CancelledViaPublicApi = 'CANCELLED_VIA_PUBLIC_API',
  CancelledViaWorkflowWeb = 'CANCELLED_VIA_WORKFLOW_WEB',
  ConcurrencyError = 'CONCURRENCY_ERROR',
  CreationError = 'CREATION_ERROR',
  Expired = 'EXPIRED',
  RefusedByCarrier = 'REFUSED_BY_CARRIER',
  SystemError = 'SYSTEM_ERROR',
}

export enum ReservationDeallocationReason {
  StockingRollback = 'STOCKING_ROLLBACK',
  UnidentifiedContent = 'UNIDENTIFIED_CONTENT',
}

export type RouterDto = {
  __typename?: 'RouterDto';
  localIpAddress?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  vpnIpAddress?: Maybe<Scalars['String']['output']>;
};

export enum SortOrder {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING',
}

export type StorageColumnDto = {
  __typename?: 'StorageColumnDto';
  columnNumber: Scalars['Int']['output'];
  depth: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  maxHorizontalUnits: Scalars['Int']['output'];
  maxVerticalUnits: Scalars['Int']['output'];
  point?: Maybe<PointDto>;
  pointId: Scalars['UUID']['output'];
  storageUnits?: Maybe<Array<StorageUnitDto>>;
};

export type StorageUnitDto = {
  __typename?: 'StorageUnitDto';
  area?: Maybe<AreaDto>;
  areaId: Scalars['UUID']['output'];
  features?: Maybe<Array<StorageUnitFeature>>;
  heightFromGroundInMillimeters: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  isEasyAccessible: Scalars['Boolean']['output'];
  isLayoutManaged: Scalars['Boolean']['output'];
  lastLockStatus?: Maybe<LockStatus>;
  lock?: Maybe<LockDto>;
  name?: Maybe<Scalars['String']['output']>;
  startingHorizontalCoordinate: Scalars['Int']['output'];
  startingVerticalCoordinate: Scalars['Int']['output'];
  statusChangeReason?: Maybe<Scalars['String']['output']>;
  storageColumn?: Maybe<StorageColumnDto>;
  storageColumnId: Scalars['UUID']['output'];
  storageUnitSize?: Maybe<StorageUnitSizeDto>;
  storageUnitSizeId: Scalars['UUID']['output'];
  storageUnitStatus: StorageUnitStatus;
};

export enum StorageUnitFeature {
  AcSocket = 'AC_SOCKET',
  Cooling = 'COOLING',
}

/** Storage unit information */
export type StorageUnitInfoDto = {
  __typename?: 'StorageUnitInfoDto';
  /** Storage unit unique identifier */
  id: Scalars['UUID']['output'];
  /** Storage unit number/name */
  name?: Maybe<Scalars['String']['output']>;
};

export type StorageUnitSizeDto = {
  __typename?: 'StorageUnitSizeDto';
  friendlyName?: Maybe<Scalars['String']['output']>;
  horizontalUnits: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  innerDepth: Scalars['Int']['output'];
  innerHeight: Scalars['Int']['output'];
  innerWidth: Scalars['Int']['output'];
  isServiceModule: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  outerDepth: Scalars['Int']['output'];
  outerHeight: Scalars['Int']['output'];
  outerWidth: Scalars['Int']['output'];
  storageUnits?: Maybe<Array<StorageUnitDto>>;
  verticalUnits: Scalars['Int']['output'];
};

export enum StorageUnitStatus {
  Blocked = 'BLOCKED',
  Broken = 'BROKEN',
  Usable = 'USABLE',
}

export enum Tag {
  Delivery = 'DELIVERY',
  Municipality = 'MUNICIPALITY',
  Private = 'PRIVATE',
  Storage = 'STORAGE',
}

export type TouchDisplayDto = {
  __typename?: 'TouchDisplayDto';
  displayRotation: DisplayRotationDirection;
  screenHeight?: Maybe<Scalars['Int']['output']>;
  screenWidth?: Maybe<Scalars['Int']['output']>;
  touchLayerRotation: DisplayRotationDirection;
};

export enum TransactionResponseCode {
  AlreadyVoided = 'ALREADY_VOIDED',
  AmountTooLowForCashback = 'AMOUNT_TOO_LOW_FOR_CASHBACK',
  Approved = 'APPROVED',
  ApprovedAlmostFullMemory = 'APPROVED_ALMOST_FULL_MEMORY',
  ApprovedFinancialTransactionAndEetTransactionDeclined = 'APPROVED_FINANCIAL_TRANSACTION_AND_EET_TRANSACTION_DECLINED',
  BadInvoiceNumber = 'BAD_INVOICE_NUMBER',
  BatchIsPendingOrMemoryIsFull = 'BATCH_IS_PENDING_OR_MEMORY_IS_FULL',
  CardNotInserted = 'CARD_NOT_INSERTED',
  CardRemoved = 'CARD_REMOVED',
  CashbackAmountTooLow = 'CASHBACK_AMOUNT_TOO_LOW',
  CashbackNotAllowed = 'CASHBACK_NOT_ALLOWED',
  ChangeOfAmountIsNotAllowed = 'CHANGE_OF_AMOUNT_IS_NOT_ALLOWED',
  DeviceIsBusy = 'DEVICE_IS_BUSY',
  DeviceRequestError = 'DEVICE_REQUEST_ERROR',
  DifferentTotalAmountFromSumOfItemsProducts = 'DIFFERENT_TOTAL_AMOUNT_FROM_SUM_OF_ITEMS_PRODUCTS',
  ErrorReadingCard = 'ERROR_READING_CARD',
  ExpiredCard = 'EXPIRED_CARD',
  IncorrectAcquirer = 'INCORRECT_ACQUIRER',
  InitNotAllowedSettleFirst = 'INIT_NOT_ALLOWED_SETTLE_FIRST',
  InvalidAmount = 'INVALID_AMOUNT',
  InvalidBarcodeLength = 'INVALID_BARCODE_LENGTH',
  InvalidCard = 'INVALID_CARD',
  InvalidCountry = 'INVALID_COUNTRY',
  InvalidManualEntry = 'INVALID_MANUAL_ENTRY',
  InvalidPhoneNumber = 'INVALID_PHONE_NUMBER',
  InvalidPin = 'INVALID_PIN',
  ManualEntryNotAllowed = 'MANUAL_ENTRY_NOT_ALLOWED',
  MaximumCashbackAmountExceeded = 'MAXIMUM_CASHBACK_AMOUNT_EXCEEDED',
  NoBatchTotals = 'NO_BATCH_TOTALS',
  NoTransactionToAbort = 'NO_TRANSACTION_TO_ABORT',
  PaperInTheTerminalPrinterRanOut = 'PAPER_IN_THE_TERMINAL_PRINTER_RAN_OUT',
  PartiallySucceeded = 'PARTIALLY_SUCCEEDED',
  PidDoesntMatch = 'PID_DOESNT_MATCH',
  PinLimitExceeded = 'PIN_LIMIT_EXCEEDED',
  PreValidCard = 'PRE_VALID_CARD',
  ProductsNotAllowed = 'PRODUCTS_NOT_ALLOWED',
  SystemNumberDuplicity = 'SYSTEM_NUMBER_DUPLICITY',
  SystemNumberMissing = 'SYSTEM_NUMBER_MISSING',
  TransactionAborted = 'TRANSACTION_ABORTED',
  TransactionFailed = 'TRANSACTION_FAILED',
  UncompletedPreAuthorizationsInBatch = 'UNCOMPLETED_PRE_AUTHORIZATIONS_IN_BATCH',
  UnknownPhoneOperator = 'UNKNOWN_PHONE_OPERATOR',
  UnknownTransaction = 'UNKNOWN_TRANSACTION',
  UnsupportedCard = 'UNSUPPORTED_CARD',
  UnsupportedSamModule = 'UNSUPPORTED_SAM_MODULE',
  UserCancelled = 'USER_CANCELLED',
  VoidNotAllowed = 'VOID_NOT_ALLOWED',
  WrongCurrency = 'WRONG_CURRENCY',
}

/** User information resolved from the Identity API */
export type UserInfoDto = {
  __typename?: 'UserInfoDto';
  /** User email address */
  email?: Maybe<Scalars['String']['output']>;
  /** User first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** User last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** User phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type AuditEventPaginatedListFragment = {
  __typename?: 'AuditEventPaginatedListDto';
  pageSize: number;
  pageIndex: number;
  totalPages: number;
  totalCount: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  items: Array<{
    __typename?: 'AuditEventDto';
    timestampUtc: string;
    eventSubject: string;
    messageName: string;
    pointId?: string | null;
    pointIdentifier?: string | null;
    pointAddress?: string | null;
    pointRegistrationNumber?: string | null;
    installationTimezone?: string | null;
    localTime?: string | null;
    trackingIdentifiers: Array<string>;
    reservationId?: string | null;
    reservationCancellationReason?: ReservationCancellationReason | null;
    reservationDeallocationReason?: ReservationDeallocationReason | null;
    tenantSubjectId?: string | null;
    tenantSubjectName?: string | null;
    courierPinCredentialId?: string | null;
    customerPinCredentialId?: string | null;
    userId?: string | null;
    lockStatus: LockStatus;
    storageUnits?: Array<{
      __typename?: 'StorageUnitInfoDto';
      id: string;
      name?: string | null;
    }> | null;
    courierCredentials?: Array<{
      __typename?: 'CourierCredential';
      type: CourierCredentialType;
      value?: string | null;
    } | null> | null;
    customerEmails?: Array<{
      __typename?: 'ClientEmail';
      email: string;
      clientType: ClientType;
    }> | null;
    customerPhoneNumbers?: Array<{
      __typename?: 'ClientPhoneNumber';
      phoneNumber: string;
      clientType: ClientType;
    }> | null;
    customerCredentials?: Array<{
      __typename?: 'CustomerCredential';
      type: CustomerCredentialType;
      value?: string | null;
    } | null> | null;
    paymentInfo?: {
      __typename?: 'PaymentInfoDto';
      amount?: string | null;
      currency?: Currency | null;
      status?: string | null;
      receiptLink?: string | null;
      paymentId?: string | null;
      transactionResponseCodeName?: TransactionResponseCode | null;
    } | null;
    metadata?: Array<{
      __typename?: 'KeyValuePairOfStringAndString';
      key: string;
      value: string;
    }> | null;
    userInfo?: {
      __typename?: 'UserInfoDto';
      email?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber?: string | null;
    } | null;
  }>;
};

export type AuditEventFragment = {
  __typename?: 'AuditEventDto';
  timestampUtc: string;
  eventSubject: string;
  messageName: string;
  pointId?: string | null;
  pointIdentifier?: string | null;
  pointAddress?: string | null;
  pointRegistrationNumber?: string | null;
  installationTimezone?: string | null;
  localTime?: string | null;
  trackingIdentifiers: Array<string>;
  reservationId?: string | null;
  reservationCancellationReason?: ReservationCancellationReason | null;
  reservationDeallocationReason?: ReservationDeallocationReason | null;
  tenantSubjectId?: string | null;
  tenantSubjectName?: string | null;
  courierPinCredentialId?: string | null;
  customerPinCredentialId?: string | null;
  userId?: string | null;
  lockStatus: LockStatus;
  storageUnits?: Array<{
    __typename?: 'StorageUnitInfoDto';
    id: string;
    name?: string | null;
  }> | null;
  courierCredentials?: Array<{
    __typename?: 'CourierCredential';
    type: CourierCredentialType;
    value?: string | null;
  } | null> | null;
  customerEmails?: Array<{
    __typename?: 'ClientEmail';
    email: string;
    clientType: ClientType;
  }> | null;
  customerPhoneNumbers?: Array<{
    __typename?: 'ClientPhoneNumber';
    phoneNumber: string;
    clientType: ClientType;
  }> | null;
  customerCredentials?: Array<{
    __typename?: 'CustomerCredential';
    type: CustomerCredentialType;
    value?: string | null;
  } | null> | null;
  paymentInfo?: {
    __typename?: 'PaymentInfoDto';
    amount?: string | null;
    currency?: Currency | null;
    status?: string | null;
    receiptLink?: string | null;
    paymentId?: string | null;
    transactionResponseCodeName?: TransactionResponseCode | null;
  } | null;
  metadata?: Array<{
    __typename?: 'KeyValuePairOfStringAndString';
    key: string;
    value: string;
  }> | null;
  userInfo?: {
    __typename?: 'UserInfoDto';
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber?: string | null;
  } | null;
};

export type ClientEmailFragment = {
  __typename?: 'ClientEmail';
  email: string;
  clientType: ClientType;
};

export type ClientPhoneNumberFragment = {
  __typename?: 'ClientPhoneNumber';
  phoneNumber: string;
  clientType: ClientType;
};

export type CompanyFragment = {
  __typename?: 'CompanyTableItemDto';
  id: string;
  subjectId: string;
  name: string;
  logoUrl?: string | null;
  logoUrlUpdatedAt?: string | null;
  type: CompanyType;
  isProvider: boolean;
  teamsMembersCount: number;
};

export type ExportSmsFragment = {
  __typename?: 'ExportSmsDto';
  pointRegistrationNumber?: string | null;
  tenantSubjectName?: string | null;
  projectName?: string | null;
  smsMessagesCount: number;
  messagesCount: number;
};

export type PaymentInfoFragment = {
  __typename?: 'PaymentInfoDto';
  amount?: string | null;
  currency?: Currency | null;
  status?: string | null;
  receiptLink?: string | null;
  paymentId?: string | null;
  transactionResponseCodeName?: TransactionResponseCode | null;
};

export type PointFragment = {
  __typename?: 'PointDto';
  id: string;
  isActive: boolean;
  isOpenForEdit: boolean;
  isConfigured: boolean;
  pointPrefix?: string | null;
  deactivationReason?: string | null;
  pointRegistrationNumber?: string | null;
  pointSequenceNumber: number;
  pointIdentifier?: string | null;
  isManualLayoutManagement: boolean;
  imageUrl?: string | null;
  installationId: string;
  internetSpeedDownloadBytes?: number | null;
  internetSpeedUploadBytes?: number | null;
  internetSpeedMeasuredAt?: string | null;
  localApplicationVersion?: string | null;
  heightFromGroundInMillimeters: number;
};

export type StorageUnitFragment = {
  __typename?: 'StorageUnitDto';
  id: string;
  name?: string | null;
  startingVerticalCoordinate: number;
  startingHorizontalCoordinate: number;
  isLayoutManaged: boolean;
  storageUnitStatus: StorageUnitStatus;
  lastLockStatus?: LockStatus | null;
  storageUnitSizeId: string;
  areaId: string;
  storageColumnId: string;
  statusChangeReason?: string | null;
  features?: Array<StorageUnitFeature> | null;
  heightFromGroundInMillimeters: number;
  isEasyAccessible: boolean;
};

export type AllAuditSubjectsQueryVariables = Exact<{ [key: string]: never }>;

export type AllAuditSubjectsQuery = {
  __typename?: 'Query';
  allAuditSubjects: {
    __typename?: 'AuditSubjects';
    point: Array<string>;
    package: Array<string>;
    courier: Array<string>;
    contact: Array<string>;
  };
};

export type CompaniesQueryVariables = Exact<{ [key: string]: never }>;

export type CompaniesQuery = {
  __typename?: 'Query';
  companies?: Array<{
    __typename?: 'CompanyTableItemDto';
    id: string;
    subjectId: string;
    name: string;
    logoUrl?: string | null;
    logoUrlUpdatedAt?: string | null;
    type: CompanyType;
    isProvider: boolean;
    teamsMembersCount: number;
  } | null> | null;
};

export type ContactAuditMessagesQueryVariables = Exact<{
  contactIdentifier: Scalars['String']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  subjects?: InputMaybe<
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>
  >;
  sortOrder?: InputMaybe<SortOrder>;
}>;

export type ContactAuditMessagesQuery = {
  __typename?: 'Query';
  contactAuditMessages?: {
    __typename?: 'AuditEventPaginatedListDto';
    pageSize: number;
    pageIndex: number;
    totalPages: number;
    totalCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: Array<{
      __typename?: 'AuditEventDto';
      timestampUtc: string;
      eventSubject: string;
      messageName: string;
      pointId?: string | null;
      pointIdentifier?: string | null;
      pointAddress?: string | null;
      pointRegistrationNumber?: string | null;
      installationTimezone?: string | null;
      localTime?: string | null;
      trackingIdentifiers: Array<string>;
      reservationId?: string | null;
      reservationCancellationReason?: ReservationCancellationReason | null;
      reservationDeallocationReason?: ReservationDeallocationReason | null;
      tenantSubjectId?: string | null;
      tenantSubjectName?: string | null;
      courierPinCredentialId?: string | null;
      customerPinCredentialId?: string | null;
      userId?: string | null;
      lockStatus: LockStatus;
      storageUnits?: Array<{
        __typename?: 'StorageUnitInfoDto';
        id: string;
        name?: string | null;
      }> | null;
      courierCredentials?: Array<{
        __typename?: 'CourierCredential';
        type: CourierCredentialType;
        value?: string | null;
      } | null> | null;
      customerEmails?: Array<{
        __typename?: 'ClientEmail';
        email: string;
        clientType: ClientType;
      }> | null;
      customerPhoneNumbers?: Array<{
        __typename?: 'ClientPhoneNumber';
        phoneNumber: string;
        clientType: ClientType;
      }> | null;
      customerCredentials?: Array<{
        __typename?: 'CustomerCredential';
        type: CustomerCredentialType;
        value?: string | null;
      } | null> | null;
      paymentInfo?: {
        __typename?: 'PaymentInfoDto';
        amount?: string | null;
        currency?: Currency | null;
        status?: string | null;
        receiptLink?: string | null;
        paymentId?: string | null;
        transactionResponseCodeName?: TransactionResponseCode | null;
      } | null;
      metadata?: Array<{
        __typename?: 'KeyValuePairOfStringAndString';
        key: string;
        value: string;
      }> | null;
      userInfo?: {
        __typename?: 'UserInfoDto';
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber?: string | null;
      } | null;
    }>;
  } | null;
};

export type CourierAuditMessagesQueryVariables = Exact<{
  courierIdentifier: Scalars['String']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  subjects?: InputMaybe<
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>
  >;
  tenantSubjectId?: InputMaybe<Scalars['UUID']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
}>;

export type CourierAuditMessagesQuery = {
  __typename?: 'Query';
  courierAuditMessages?: {
    __typename?: 'AuditEventPaginatedListDto';
    pageSize: number;
    pageIndex: number;
    totalPages: number;
    totalCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: Array<{
      __typename?: 'AuditEventDto';
      timestampUtc: string;
      eventSubject: string;
      messageName: string;
      pointId?: string | null;
      pointIdentifier?: string | null;
      pointAddress?: string | null;
      pointRegistrationNumber?: string | null;
      installationTimezone?: string | null;
      localTime?: string | null;
      trackingIdentifiers: Array<string>;
      reservationId?: string | null;
      reservationCancellationReason?: ReservationCancellationReason | null;
      reservationDeallocationReason?: ReservationDeallocationReason | null;
      tenantSubjectId?: string | null;
      tenantSubjectName?: string | null;
      courierPinCredentialId?: string | null;
      customerPinCredentialId?: string | null;
      userId?: string | null;
      lockStatus: LockStatus;
      storageUnits?: Array<{
        __typename?: 'StorageUnitInfoDto';
        id: string;
        name?: string | null;
      }> | null;
      courierCredentials?: Array<{
        __typename?: 'CourierCredential';
        type: CourierCredentialType;
        value?: string | null;
      } | null> | null;
      customerEmails?: Array<{
        __typename?: 'ClientEmail';
        email: string;
        clientType: ClientType;
      }> | null;
      customerPhoneNumbers?: Array<{
        __typename?: 'ClientPhoneNumber';
        phoneNumber: string;
        clientType: ClientType;
      }> | null;
      customerCredentials?: Array<{
        __typename?: 'CustomerCredential';
        type: CustomerCredentialType;
        value?: string | null;
      } | null> | null;
      paymentInfo?: {
        __typename?: 'PaymentInfoDto';
        amount?: string | null;
        currency?: Currency | null;
        status?: string | null;
        receiptLink?: string | null;
        paymentId?: string | null;
        transactionResponseCodeName?: TransactionResponseCode | null;
      } | null;
      metadata?: Array<{
        __typename?: 'KeyValuePairOfStringAndString';
        key: string;
        value: string;
      }> | null;
      userInfo?: {
        __typename?: 'UserInfoDto';
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber?: string | null;
      } | null;
    }>;
  } | null;
};

export type PackageAuditMessagesQueryVariables = Exact<{
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  subjects?: InputMaybe<
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>
  >;
  sortOrder?: InputMaybe<SortOrder>;
}>;

export type PackageAuditMessagesQuery = {
  __typename?: 'Query';
  packageAuditMessages?: {
    __typename?: 'AuditEventPaginatedListDto';
    pageSize: number;
    pageIndex: number;
    totalPages: number;
    totalCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: Array<{
      __typename?: 'AuditEventDto';
      timestampUtc: string;
      eventSubject: string;
      messageName: string;
      pointId?: string | null;
      pointIdentifier?: string | null;
      pointAddress?: string | null;
      pointRegistrationNumber?: string | null;
      installationTimezone?: string | null;
      localTime?: string | null;
      trackingIdentifiers: Array<string>;
      reservationId?: string | null;
      reservationCancellationReason?: ReservationCancellationReason | null;
      reservationDeallocationReason?: ReservationDeallocationReason | null;
      tenantSubjectId?: string | null;
      tenantSubjectName?: string | null;
      courierPinCredentialId?: string | null;
      customerPinCredentialId?: string | null;
      userId?: string | null;
      lockStatus: LockStatus;
      storageUnits?: Array<{
        __typename?: 'StorageUnitInfoDto';
        id: string;
        name?: string | null;
      }> | null;
      courierCredentials?: Array<{
        __typename?: 'CourierCredential';
        type: CourierCredentialType;
        value?: string | null;
      } | null> | null;
      customerEmails?: Array<{
        __typename?: 'ClientEmail';
        email: string;
        clientType: ClientType;
      }> | null;
      customerPhoneNumbers?: Array<{
        __typename?: 'ClientPhoneNumber';
        phoneNumber: string;
        clientType: ClientType;
      }> | null;
      customerCredentials?: Array<{
        __typename?: 'CustomerCredential';
        type: CustomerCredentialType;
        value?: string | null;
      } | null> | null;
      paymentInfo?: {
        __typename?: 'PaymentInfoDto';
        amount?: string | null;
        currency?: Currency | null;
        status?: string | null;
        receiptLink?: string | null;
        paymentId?: string | null;
        transactionResponseCodeName?: TransactionResponseCode | null;
      } | null;
      metadata?: Array<{
        __typename?: 'KeyValuePairOfStringAndString';
        key: string;
        value: string;
      }> | null;
      userInfo?: {
        __typename?: 'UserInfoDto';
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber?: string | null;
      } | null;
    }>;
  } | null;
};

export type PointAuditMessagesQueryVariables = Exact<{
  pointId?: InputMaybe<Scalars['UUID']['input']>;
  storageUnitId?: InputMaybe<Scalars['UUID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  subjects?: InputMaybe<
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>
  >;
  sortOrder?: InputMaybe<SortOrder>;
}>;

export type PointAuditMessagesQuery = {
  __typename?: 'Query';
  pointAuditMessages?: {
    __typename?: 'AuditEventPaginatedListDto';
    pageSize: number;
    pageIndex: number;
    totalPages: number;
    totalCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: Array<{
      __typename?: 'AuditEventDto';
      timestampUtc: string;
      eventSubject: string;
      messageName: string;
      pointId?: string | null;
      pointIdentifier?: string | null;
      pointAddress?: string | null;
      pointRegistrationNumber?: string | null;
      installationTimezone?: string | null;
      localTime?: string | null;
      trackingIdentifiers: Array<string>;
      reservationId?: string | null;
      reservationCancellationReason?: ReservationCancellationReason | null;
      reservationDeallocationReason?: ReservationDeallocationReason | null;
      tenantSubjectId?: string | null;
      tenantSubjectName?: string | null;
      courierPinCredentialId?: string | null;
      customerPinCredentialId?: string | null;
      userId?: string | null;
      lockStatus: LockStatus;
      storageUnits?: Array<{
        __typename?: 'StorageUnitInfoDto';
        id: string;
        name?: string | null;
      }> | null;
      courierCredentials?: Array<{
        __typename?: 'CourierCredential';
        type: CourierCredentialType;
        value?: string | null;
      } | null> | null;
      customerEmails?: Array<{
        __typename?: 'ClientEmail';
        email: string;
        clientType: ClientType;
      }> | null;
      customerPhoneNumbers?: Array<{
        __typename?: 'ClientPhoneNumber';
        phoneNumber: string;
        clientType: ClientType;
      }> | null;
      customerCredentials?: Array<{
        __typename?: 'CustomerCredential';
        type: CustomerCredentialType;
        value?: string | null;
      } | null> | null;
      paymentInfo?: {
        __typename?: 'PaymentInfoDto';
        amount?: string | null;
        currency?: Currency | null;
        status?: string | null;
        receiptLink?: string | null;
        paymentId?: string | null;
        transactionResponseCodeName?: TransactionResponseCode | null;
      } | null;
      metadata?: Array<{
        __typename?: 'KeyValuePairOfStringAndString';
        key: string;
        value: string;
      }> | null;
      userInfo?: {
        __typename?: 'UserInfoDto';
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber?: string | null;
      } | null;
    }>;
  } | null;
};

export type PointsQueryVariables = Exact<{ [key: string]: never }>;

export type PointsQuery = {
  __typename?: 'Query';
  points?: Array<{
    __typename?: 'PointMessageDto';
    id: string;
    pointSequenceNumber: number;
    pointRegistrationNumber?: string | null;
    pointIdentifier?: string | null;
  } | null> | null;
};

export type SentSmsLogsQueryVariables = Exact<{
  smsSentAtFrom?: InputMaybe<Scalars['String']['input']>;
  smsSentAtTo?: InputMaybe<Scalars['String']['input']>;
}>;

export type SentSmsLogsQuery = {
  __typename?: 'Query';
  sentSmsLogs: Array<{
    __typename?: 'ExportSmsDto';
    pointRegistrationNumber?: string | null;
    tenantSubjectName?: string | null;
    projectName?: string | null;
    smsMessagesCount: number;
    messagesCount: number;
  }>;
};

export type StorageUnitsByPointQueryVariables = Exact<{
  pointId: Scalars['UUID']['input'];
}>;

export type StorageUnitsByPointQuery = {
  __typename?: 'Query';
  storageUnitsByPoint: Array<{
    __typename?: 'StorageUnitDto';
    id: string;
    name?: string | null;
    startingVerticalCoordinate: number;
    startingHorizontalCoordinate: number;
    isLayoutManaged: boolean;
    storageUnitStatus: StorageUnitStatus;
    lastLockStatus?: LockStatus | null;
    storageUnitSizeId: string;
    areaId: string;
    storageColumnId: string;
    statusChangeReason?: string | null;
    features?: Array<StorageUnitFeature> | null;
    heightFromGroundInMillimeters: number;
    isEasyAccessible: boolean;
  }>;
};

export const ClientEmailFragmentDoc = `
    fragment ClientEmail on ClientEmail {
  email
  clientType
}
    `;
export const ClientPhoneNumberFragmentDoc = `
    fragment ClientPhoneNumber on ClientPhoneNumber {
  phoneNumber
  clientType
}
    `;
export const PaymentInfoFragmentDoc = `
    fragment PaymentInfo on PaymentInfoDto {
  amount
  currency
  status
  receiptLink
  paymentId
  transactionResponseCodeName
}
    `;
export const AuditEventFragmentDoc = `
    fragment AuditEvent on AuditEventDto {
  timestampUtc
  eventSubject
  messageName
  pointId
  pointIdentifier
  pointAddress
  pointRegistrationNumber
  installationTimezone
  localTime
  storageUnits {
    id
    name
  }
  trackingIdentifiers
  reservationId
  reservationCancellationReason
  reservationDeallocationReason
  tenantSubjectId
  tenantSubjectName
  courierPinCredentialId
  courierCredentials {
    type
    value
  }
  customerEmails {
    ...ClientEmail
  }
  customerPhoneNumbers {
    ...ClientPhoneNumber
  }
  customerPinCredentialId
  customerCredentials {
    type
    value
  }
  paymentInfo {
    ...PaymentInfo
  }
  userId
  lockStatus
  metadata {
    key
    value
  }
  userInfo {
    email
    firstName
    lastName
    phoneNumber
  }
}
    `;
export const AuditEventPaginatedListFragmentDoc = `
    fragment AuditEventPaginatedList on AuditEventPaginatedListDto {
  items {
    ...AuditEvent
  }
  pageSize
  pageIndex
  totalPages
  totalCount
  hasPreviousPage
  hasNextPage
}
    `;
export const CompanyFragmentDoc = `
    fragment Company on CompanyTableItemDto {
  id
  subjectId
  name
  logoUrl
  logoUrlUpdatedAt
  type
  isProvider
  teamsMembersCount
}
    `;
export const ExportSmsFragmentDoc = `
    fragment ExportSms on ExportSmsDto {
  pointRegistrationNumber
  tenantSubjectName
  projectName
  smsMessagesCount
  messagesCount
}
    `;
export const PointFragmentDoc = `
    fragment Point on PointDto {
  id
  isActive
  isOpenForEdit
  isConfigured
  pointPrefix
  deactivationReason
  pointRegistrationNumber
  pointSequenceNumber
  pointIdentifier
  isManualLayoutManagement
  imageUrl
  installationId
  internetSpeedDownloadBytes
  internetSpeedUploadBytes
  internetSpeedMeasuredAt
  localApplicationVersion
  heightFromGroundInMillimeters
}
    `;
export const StorageUnitFragmentDoc = `
    fragment StorageUnit on StorageUnitDto {
  id
  name
  startingVerticalCoordinate
  startingHorizontalCoordinate
  isLayoutManaged
  storageUnitStatus
  lastLockStatus
  storageUnitSizeId
  areaId
  storageColumnId
  statusChangeReason
  features
  heightFromGroundInMillimeters
  isEasyAccessible
}
    `;
export const AllAuditSubjectsDocument = `
    query AllAuditSubjects {
  allAuditSubjects {
    point
    package
    courier
    contact
  }
}
    `;

export const useAllAuditSubjectsQuery = <
  TData = AllAuditSubjectsQuery,
  TError = unknown,
>(
  variables?: AllAuditSubjectsQueryVariables,
  options?: Omit<
    UseQueryOptions<AllAuditSubjectsQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<
      AllAuditSubjectsQuery,
      TError,
      TData
    >['queryKey'];
  }
) => {
  return useQuery<AllAuditSubjectsQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['AllAuditSubjects']
        : ['AllAuditSubjects', variables],
    queryFn: fetcher<AllAuditSubjectsQuery, AllAuditSubjectsQueryVariables>(
      AllAuditSubjectsDocument,
      variables
    ),
    ...options,
  });
};

export const CompaniesDocument = `
    query Companies {
  companies {
    ...Company
  }
}
    ${CompanyFragmentDoc}`;

export const useCompaniesQuery = <TData = CompaniesQuery, TError = unknown>(
  variables?: CompaniesQueryVariables,
  options?: Omit<UseQueryOptions<CompaniesQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<CompaniesQuery, TError, TData>['queryKey'];
  }
) => {
  return useQuery<CompaniesQuery, TError, TData>({
    queryKey:
      variables === undefined ? ['Companies'] : ['Companies', variables],
    queryFn: fetcher<CompaniesQuery, CompaniesQueryVariables>(
      CompaniesDocument,
      variables
    ),
    ...options,
  });
};

export const ContactAuditMessagesDocument = `
    query ContactAuditMessages($contactIdentifier: String!, $from: DateTime, $to: DateTime, $pageIndex: Int, $pageSize: Int, $subjects: [String], $sortOrder: SortOrder) {
  contactAuditMessages(
    contactIdentifier: $contactIdentifier
    from: $from
    to: $to
    pageIndex: $pageIndex
    pageSize: $pageSize
    subjects: $subjects
    sortOrder: $sortOrder
  ) {
    ...AuditEventPaginatedList
  }
}
    ${AuditEventPaginatedListFragmentDoc}
${AuditEventFragmentDoc}
${ClientEmailFragmentDoc}
${ClientPhoneNumberFragmentDoc}
${PaymentInfoFragmentDoc}`;

export const useContactAuditMessagesQuery = <
  TData = ContactAuditMessagesQuery,
  TError = unknown,
>(
  variables: ContactAuditMessagesQueryVariables,
  options?: Omit<
    UseQueryOptions<ContactAuditMessagesQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<
      ContactAuditMessagesQuery,
      TError,
      TData
    >['queryKey'];
  }
) => {
  return useQuery<ContactAuditMessagesQuery, TError, TData>({
    queryKey: ['ContactAuditMessages', variables],
    queryFn: fetcher<
      ContactAuditMessagesQuery,
      ContactAuditMessagesQueryVariables
    >(ContactAuditMessagesDocument, variables),
    ...options,
  });
};

export const CourierAuditMessagesDocument = `
    query CourierAuditMessages($courierIdentifier: String!, $from: DateTime, $to: DateTime, $pageIndex: Int, $pageSize: Int, $subjects: [String], $tenantSubjectId: UUID, $sortOrder: SortOrder) {
  courierAuditMessages(
    courierIdentifier: $courierIdentifier
    from: $from
    to: $to
    pageIndex: $pageIndex
    pageSize: $pageSize
    subjects: $subjects
    tenantSubjectId: $tenantSubjectId
    sortOrder: $sortOrder
  ) {
    ...AuditEventPaginatedList
  }
}
    ${AuditEventPaginatedListFragmentDoc}
${AuditEventFragmentDoc}
${ClientEmailFragmentDoc}
${ClientPhoneNumberFragmentDoc}
${PaymentInfoFragmentDoc}`;

export const useCourierAuditMessagesQuery = <
  TData = CourierAuditMessagesQuery,
  TError = unknown,
>(
  variables: CourierAuditMessagesQueryVariables,
  options?: Omit<
    UseQueryOptions<CourierAuditMessagesQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<
      CourierAuditMessagesQuery,
      TError,
      TData
    >['queryKey'];
  }
) => {
  return useQuery<CourierAuditMessagesQuery, TError, TData>({
    queryKey: ['CourierAuditMessages', variables],
    queryFn: fetcher<
      CourierAuditMessagesQuery,
      CourierAuditMessagesQueryVariables
    >(CourierAuditMessagesDocument, variables),
    ...options,
  });
};

export const PackageAuditMessagesDocument = `
    query PackageAuditMessages($trackingNumber: String, $from: DateTime, $to: DateTime, $pageIndex: Int, $pageSize: Int, $subjects: [String], $sortOrder: SortOrder) {
  packageAuditMessages(
    trackingNumber: $trackingNumber
    from: $from
    to: $to
    pageIndex: $pageIndex
    pageSize: $pageSize
    subjects: $subjects
    sortOrder: $sortOrder
  ) {
    ...AuditEventPaginatedList
  }
}
    ${AuditEventPaginatedListFragmentDoc}
${AuditEventFragmentDoc}
${ClientEmailFragmentDoc}
${ClientPhoneNumberFragmentDoc}
${PaymentInfoFragmentDoc}`;

export const usePackageAuditMessagesQuery = <
  TData = PackageAuditMessagesQuery,
  TError = unknown,
>(
  variables?: PackageAuditMessagesQueryVariables,
  options?: Omit<
    UseQueryOptions<PackageAuditMessagesQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<
      PackageAuditMessagesQuery,
      TError,
      TData
    >['queryKey'];
  }
) => {
  return useQuery<PackageAuditMessagesQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['PackageAuditMessages']
        : ['PackageAuditMessages', variables],
    queryFn: fetcher<
      PackageAuditMessagesQuery,
      PackageAuditMessagesQueryVariables
    >(PackageAuditMessagesDocument, variables),
    ...options,
  });
};

export const PointAuditMessagesDocument = `
    query PointAuditMessages($pointId: UUID, $storageUnitId: UUID, $from: DateTime, $to: DateTime, $pageIndex: Int, $pageSize: Int, $subjects: [String], $sortOrder: SortOrder) {
  pointAuditMessages(
    pointId: $pointId
    storageUnitId: $storageUnitId
    from: $from
    to: $to
    pageIndex: $pageIndex
    pageSize: $pageSize
    subjects: $subjects
    sortOrder: $sortOrder
  ) {
    ...AuditEventPaginatedList
  }
}
    ${AuditEventPaginatedListFragmentDoc}
${AuditEventFragmentDoc}
${ClientEmailFragmentDoc}
${ClientPhoneNumberFragmentDoc}
${PaymentInfoFragmentDoc}`;

export const usePointAuditMessagesQuery = <
  TData = PointAuditMessagesQuery,
  TError = unknown,
>(
  variables?: PointAuditMessagesQueryVariables,
  options?: Omit<
    UseQueryOptions<PointAuditMessagesQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<
      PointAuditMessagesQuery,
      TError,
      TData
    >['queryKey'];
  }
) => {
  return useQuery<PointAuditMessagesQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['PointAuditMessages']
        : ['PointAuditMessages', variables],
    queryFn: fetcher<PointAuditMessagesQuery, PointAuditMessagesQueryVariables>(
      PointAuditMessagesDocument,
      variables
    ),
    ...options,
  });
};

export const PointsDocument = `
    query Points {
  points {
    id
    pointSequenceNumber
    pointRegistrationNumber
    pointIdentifier
  }
}
    `;

export const usePointsQuery = <TData = PointsQuery, TError = unknown>(
  variables?: PointsQueryVariables,
  options?: Omit<UseQueryOptions<PointsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<PointsQuery, TError, TData>['queryKey'];
  }
) => {
  return useQuery<PointsQuery, TError, TData>({
    queryKey: variables === undefined ? ['Points'] : ['Points', variables],
    queryFn: fetcher<PointsQuery, PointsQueryVariables>(
      PointsDocument,
      variables
    ),
    ...options,
  });
};

export const SentSmsLogsDocument = `
    query SentSmsLogs($smsSentAtFrom: String, $smsSentAtTo: String) {
  sentSmsLogs(smsSentAtFrom: $smsSentAtFrom, smsSentAtTo: $smsSentAtTo) {
    ...ExportSms
  }
}
    ${ExportSmsFragmentDoc}`;

export const useSentSmsLogsQuery = <TData = SentSmsLogsQuery, TError = unknown>(
  variables?: SentSmsLogsQueryVariables,
  options?: Omit<
    UseQueryOptions<SentSmsLogsQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<SentSmsLogsQuery, TError, TData>['queryKey'];
  }
) => {
  return useQuery<SentSmsLogsQuery, TError, TData>({
    queryKey:
      variables === undefined ? ['SentSmsLogs'] : ['SentSmsLogs', variables],
    queryFn: fetcher<SentSmsLogsQuery, SentSmsLogsQueryVariables>(
      SentSmsLogsDocument,
      variables
    ),
    ...options,
  });
};

export const StorageUnitsByPointDocument = `
    query StorageUnitsByPoint($pointId: UUID!) {
  storageUnitsByPoint(pointId: $pointId) {
    ...StorageUnit
  }
}
    ${StorageUnitFragmentDoc}`;

export const useStorageUnitsByPointQuery = <
  TData = StorageUnitsByPointQuery,
  TError = unknown,
>(
  variables: StorageUnitsByPointQueryVariables,
  options?: Omit<
    UseQueryOptions<StorageUnitsByPointQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<
      StorageUnitsByPointQuery,
      TError,
      TData
    >['queryKey'];
  }
) => {
  return useQuery<StorageUnitsByPointQuery, TError, TData>({
    queryKey: ['StorageUnitsByPoint', variables],
    queryFn: fetcher<
      StorageUnitsByPointQuery,
      StorageUnitsByPointQueryVariables
    >(StorageUnitsByPointDocument, variables),
    ...options,
  });
};
